/**
 * Image Slider
 */

import Swiper, { Navigation, Pagination } from 'swiper/core';

Swiper.use([Navigation, Pagination]);

const pageCover = {
    cfg: {

        slider: '.js-pageCover',
        sliderOptions: {
            // speed: 500,
            effect: 'fade',
            loop: true,

            observer: true, 
            observeParents: true,
            allowTouchMove: false,

            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            

            navigation: {
                nextEl: '.swiper-extnav .swiper-button-next',
                prevEl: '.swiper-extnav .swiper-button-prev',
            },

            /* eslint-disable */
            pagination: {
                el: '.swiper-extnav .swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">0' + (index + 1) + '</span>';
                },
              },
            /* eslint-enable */

            on: {
                init() {
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 600);
                },
            },
        }
    },

    init() {
        const sliders = [...document.querySelectorAll(this.cfg.slider)];
        if (sliders) {
            sliders.forEach((slider) => {
                const mySwiper = new Swiper(slider, this.cfg.sliderOptions);

                mySwiper.update();

                setTimeout(() => {
                    mySwiper.update();
                }, 500);
            });
        }
    }
};

export default pageCover;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/pageCover/_script.js